import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Tooltip } from 'antd'
import './text-popover.scss'
import useBemClass from '@/utils/hooks/useBEMClass'

interface TextPopoverProps {
    title: string
    width: number
    keyWord?: string
    style?: React.CSSProperties
}

const TextPopover: React.FC<TextPopoverProps> = props => {
    const contentRef = useRef<HTMLSpanElement | null>(null)
    const [showTooltip, setShowTooltip] = useState<boolean>(false)
    const cls = useBemClass('text-popover-content')

    useEffect(() => {
        if (contentRef.current) {
            setShowTooltip(contentRef.current.scrollWidth > props.width)
        }
    }, [props.width, props.title])

    const innerText = useMemo(() => {
        if (props.keyWord) {
            return props.title.replace(props.keyWord, `<span style="color:#14cc9b">${props.keyWord}</span>`)
        } else {
            return props.title
        }
    }, [props.keyWord, props.title])

    return (
        <Tooltip
            overlayStyle={
                !showTooltip
                    ? {
                          display: 'none',
                      }
                    : void 0
            }
            placement="topLeft"
            title={props.title}
        >
            <span
                ref={contentRef}
                className={cls('content')}
                style={{
                    maxWidth: `${props.width}px`,
                    ...(props.style ? props.style : {}),
                }}
                dangerouslySetInnerHTML={{ __html: innerText }}
            />
        </Tooltip>
    )
}

export default TextPopover
